<template>
  <section class="terms container">
    <BreadCrumb />
    <div class="top-heading">
      <h2 class="font-34 bold">
        {{ _.get(contentData, "data.list[0].title") }}
      </h2>

      <p class="lh-34 bold">
        {{ _.get(contentData, "data.list[0].teaser") }}
      </p>
    </div>

    <div class="terms-grid">
      <template
        v-for="(item, index) in _.get(contentData, 'data.list[0].content.tabs')"
      >
        <div class="terms-item" :key="index">
          <h3 class="font-21 bold">{{ item.title }}</h3>

          <div class="text lh-34" v-html="item.content"></div>
        </div>
      </template>
    </div>
    <div class="variation">
      <h3 class="font-21 bold">{{ $fn.tr("ვარიაცია") }}</h3>
      <p class="lh-34 bold">
        {{
          $fn.tr(
            "ეს პირობები შეიძლება შეიცვალოს და შეიძლება შეიცვალოს ნებისმიერ დროს გაფრთხილების გარეშე."
          )
        }}
      </p>
    </div>
  </section>
</template>
<script>
import BreadCrumb from "@/components/modules/BreadCrumb";
export default {
  props: ["contentData"],
  components: {BreadCrumb},
};
</script>

<style lang="scss">
.terms {
  // padding-top: 55px;
  padding-bottom: 144px;
  @media (max-width: 1439px) {
    padding-bottom: 89px;
  }
  @media (max-width: 1023px) {
    padding-top: 34px;
    padding-bottom: 55px;
  }
  .top-heading {
    margin-bottom: 89px;
    padding-bottom: 89px;
    border-bottom: 2px solid rgba(26, 26, 26, 0.1);
    @media (max-width: 1365px) {
      margin-bottom: 55px;
      padding-bottom: 55px;
    }
    h2 {
      margin-bottom: 34px;
    }
    p {
      color: $lightGray2;
    }
  }
  .terms-grid {
    display: grid;
    grid-row-gap: 89px;
    grid-column-gap: 30px;
    grid-template-columns: repeat(2, minmax(0px, 1fr));
    @media (max-width: 767px) {
      grid-template-columns: repeat(1, minmax(0px, 1fr));
      grid-row-gap: 55px;
    }
    .terms-item {
      padding-bottom: 89px;
      border-bottom: 2px solid rgba(26, 26, 26, 0.1);
      @media (max-width: 767px) {
        padding-bottom: 55px;
      }
      h3 {
        margin-bottom: 21px;
      }
    }
  }
  .variation {
    margin-top: 55px;
    width: 50%;
    @media (max-width: 767px) {
      width: 100%;
    }
    h3 {
      margin-bottom: 21px;
    }
    p {
      color: $lightGray2;
    }
  }
}
</style>
